import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { AppButton, AppForm } from "@/shared/Components";
import { FormInputPassword } from "@/shared/Components/Form/FormInputs/FormInputPassword";
import type { PinCodeFormValues } from "../../model";
import { getCreatePinSchema } from "../../model";
import styles from "./styles.module.scss";

type Props = {
  onSubmit: (pin: string) => void;
  loading?: boolean;
};

export const PinCodeForm = ({ onSubmit, loading }: Props) => {
  const { t } = useTranslation();
  const formApi = useForm({
    resolver: yupResolver(getCreatePinSchema()),
  });

  const handleSubmit = (data: PinCodeFormValues) => {
    onSubmit(data.pin);
  };

  return (
    <AppForm formApi={formApi} onSubmit={handleSubmit} className={styles.container}>
      <h1 className={styles.title}>{t("registrationPage.createPinStep.createPin")}</h1>
      <div className={styles.inputs}>
        <FormInputPassword
          name="pin"
          placeholder={t("registrationPage.createPinStep.pin")}
          className={styles["registration-input"]}
        />
        <FormInputPassword
          name="confirmPin"
          placeholder={t("registrationPage.createPinStep.confirmPin")}
          className={styles["registration-input"]}
        />
      </div>
      <AppButton htmlType="submit" type="primary" className={styles.submit} loading={loading}>
        {t("registrationPage.createPinStep.create")}
      </AppButton>
    </AppForm>
  );
};
